// import { BatchDownloadItem } from '@/utils';
import { ErrorCode, Status, BatchDownloadItem, GlobalStatus, GlobalStatusText } from "../type";
import { ResetErrorCode } from "@/components/Joyspace/types";
export function checkDownloadError(status: ErrorCode | ResetErrorCode) {
  return (
    status === ErrorCode.ERROR ||
    status === ErrorCode.FILE_DEL_ERROR ||
    status === ErrorCode.NETWORK_ERROR ||
    status === ErrorCode.NO_PERMISSION ||
    status === ResetErrorCode.noPermission ||
    status === ResetErrorCode.Delete ||
    status === ErrorCode.PRIVATENET_EGOV_FILE ||
    status === ErrorCode.FILE_EXPIRED ||
    status === ErrorCode.PATH_NOT_EXIST
  );
}

// 判断是否有等待下载或者下载中的状态
export function checkDownloadProgress(list: BatchDownloadItem[]) {
  return list.some(
    (item: BatchDownloadItem) => item.status === Status.WAITING || item.status === Status.PROGRESS
  );
}
// 校验是否全部下载成功
export function checkDownloadSuccessAll(list: BatchDownloadItem[]) {
  return (
    list.filter((item: BatchDownloadItem) => item.status === Status.SUCCESS).length === list.length
  );
}

// 校验是否全部下载失败
export function checkDownloadErrorAll(list: BatchDownloadItem[]) {
  return (
    list.filter((item: BatchDownloadItem) => checkDownloadError(item.status as any)).length ===
    list.length
  );
}

// 下载取消
export function checkDownloadCancelAll(list: BatchDownloadItem[]) {
  const tmpList = list.filter(
    (item: BatchDownloadItem) =>
      !checkDownloadError(item.status as any) &&
      item.status !== Status.WAITING &&
      item.status !== Status.PROGRESS
  );
  return tmpList.some((item: BatchDownloadItem) => item.status === Status.CANCEL);
}

// 部分下载失败
export function checkDownloadMoietyError(list: BatchDownloadItem[]) {
  const tmpList = list.filter(
    (item: BatchDownloadItem) => item.status !== Status.WAITING && item.status !== Status.PROGRESS
  );
  console.log(list, "listlistlistlistlistlist", tmpList);
  return tmpList.some((item: BatchDownloadItem) => checkDownloadError(item.status as any));
}

// 获取全局状态
export function getGlobalStatus(list: BatchDownloadItem[]) {
  if (checkDownloadProgress(list)) {
    return GlobalStatus.PROGRESS_ALL;
  }
  if (checkDownloadErrorAll(list)) {
    return GlobalStatus.ERROR_ALL;
  }
  if (checkDownloadSuccessAll(list)) {
    return GlobalStatus.SUCCESS_ALL;
  }
  if (checkDownloadMoietyError(list)) {
    return GlobalStatus.MOIETY_ERROR;
  }
  if (checkDownloadCancelAll(list)) {
    return GlobalStatus.CANCEL_ALL;
  }
  return GlobalStatus.ERROR_ALL;
}
// 获取全局状态test
export function getGlobalStatusText(status: GlobalStatus) {
  switch (status) {
    case GlobalStatus.PROGRESS_ALL:
      return GlobalStatusText.PROGRESS_ALL;
    case GlobalStatus.CANCEL_ALL:
      return GlobalStatusText.CANCEL_ALL;
    case GlobalStatus.SUCCESS_ALL:
      return GlobalStatusText.SUCCESS_ALL;
    case GlobalStatus.MOIETY_ERROR:
      return GlobalStatusText.MOIETY_ERROR;
    default:
    case GlobalStatus.ERROR_ALL:
      return GlobalStatusText.ERROR_ALL;
  }
}

// 获取正在下载任务数量
export function getCurrentDownloadTaskCount(list: BatchDownloadItem[]) {
  return list.filter(
    (item: BatchDownloadItem) => item.status === Status.WAITING || item.status === Status.PROGRESS
  ).length;
}
// 获取已完成下载任务数量
export function getSuccessDownloadTaskCount(list: BatchDownloadItem[]) {
  return list.filter((item: BatchDownloadItem) => item.status === Status.SUCCESS).length;
}
